import styled from 'styled-components';

import inputStyles from './inputStyles';

/**
* IMPORTANT!
* These are global styles that applies to EVERY textarea of every theme.
*
* Please avoid making changes as much as possible.
* If you can achieve your goal by creating a new theme, please do so.
* If you HAVE TO make a chance, please check EVERY story
* on storybook to make sure everything renders correctly!
*/
export default styled.textarea`
  ${inputStyles};
  padding: ${p => p.theme.spacing.small};
  resize: none;
`;
